import { useMutation } from '@apollo/client';
import { CREATE_AI_FEATURE_FEEDBACK } from '@nile/banyan/src/Graphql/Mutations/ai';
import {
  AIComponent,
  EventEmitter,
  getAIRephraseKeys,
  getTranslatedText,
  withErrorBoundary
} from '@nile/components';
import { dompurifier, getAIPrompts } from '@nile/components/src/Utils/helpers';
import { AccountClient, APPLY_AI_PROMPT } from '@nile/graphql/src';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

const TicketAIRephrase = ({
  editorRef,
  mixpanelEventOnClick,
  mixpanelEventOnCopy
}) => {
  const AIPrompts = getAIPrompts();

  const intl = useIntl();

  const onRephraseCopy = useCallback((content, params) => {
    if (editorRef.current?.FroalaEditorRef) {
      EventEmitter.dispatch('insertEditorContent', dompurifier(content));
    } else {
      EventEmitter.dispatch('replaceEditorContent', dompurifier(content));
    }
  }, []);

  const [
    sendAIFeatureFeedback,
    { loading: aiFeatureFeedbackLoading }
  ] = useMutation(CREATE_AI_FEATURE_FEEDBACK, {
    client: AccountClient,
    onCompleted(res) {
      console.log(res, 'ash:: AI feature feedback res');
    }
  });

  const aiRephraseKeys = getAIRephraseKeys(intl);

  const onAIRephraseFeedback = useCallback(
    (params) => {
      const featureId = params?.data?.currentPrompt?.featureId;
      const actualMessage = params?.data?.selectedText;
      const thumbsUp = params?.type === 'HELPFUL';
      const response = params?.response;

      if (featureId && actualMessage && response && sendAIFeatureFeedback) {
        const input = {
          feature: {
            featureId: featureId
          },
          ratingType: 'THUMBS',
          rating: thumbsUp ? '1' : '0', // 0 for down thumps
          prompt: {
            actualMessage: actualMessage,
            aiMessage: response
          }
        };

        sendAIFeatureFeedback({
          variables: {
            input: input
          }
        });
      }
    },
    [sendAIFeatureFeedback]
  );

  return (
    <div>
      <AIComponent
        editorRef={editorRef}
        onCopy={onRephraseCopy}
        type="REPHRASE"
        hideButtonText
        prompts={AIPrompts || []}
        data={{
          Api: APPLY_AI_PROMPT,
          accessorKey: 'applyAIPrompt'
        }}
        sendFeedback={onAIRephraseFeedback}
        featureName="PROMPT_BUILDER"
        headingText={getTranslatedText(intl, 'common.rephrase.text')}
        headingIcon="AIWand"
        loadingText={aiRephraseKeys?.loadingText}
        successText={aiRephraseKeys?.successText}
        copyButtonText={getTranslatedText(intl, 'common.insert.text')}
        copySuccessText={getTranslatedText(intl, 'common.inserted')}
        mixpanelEventOnClick={mixpanelEventOnClick}
        mixpanelEventOnCopy={mixpanelEventOnCopy}
      />
    </div>
  );
};

export default withErrorBoundary(TicketAIRephrase);
